<template>
  <Modal id="delete-profile" #default="{ close }">
    <h2>{{ $t('ModalDeleteProfileTitle') }}</h2>
    <div class="actions">
      <button class="primary">{{ $t('yes') }}</button>
      <button @click="close">{{ $t('cancel') }}</button>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/modals/Modal'

export default {
  name: 'ModalDeleteProfile',
  components: { Modal },
}
</script>

<style lang="scss">
#modal-delete-profile {
  h2 {
    margin-bottom: 32px;
  }
}
</style>
